import { useCallback, useContext, useReducer } from "react";
import CompetitionDropdown from "../components/forms/Dropdowns/CompetitionDropdown"
import { UserDataContext } from "../firebase/UserDataContext";
import { Alert, Box, Button, Checkbox, FormControlLabel, FormGroup, IconButton, InputAdornment, Paper, Snackbar, Stack, TextField, Tooltip, Typography } from "@mui/material";
import { FirebaseNewContext } from "../firebase/FirebaseNewContext";
import { CommonDataContext } from "../firebase/CommonDataContext";
import { GlobalSettingsContext } from "../firebase/GlobalSettingsContext";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import FormErrorMessages from "../components/forms/Messages/FormErrorMessages";
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import React from 'react';

function accountPageInitalState(values) {
    return {
        defaultCompetition: values.defaultCompetition,
        password: {
            new: '',
            newShow: false,
            newConfirm: '',
            newConfirmShow: false,
            messages: []
        },
        email: {
            current: '',
            new: '',
            newConfirm: '',
            messages: []
        },
        settings: {
            scoresheetNew: values.scoresheetNew
        }
    }
}
function accountPageReducer(state, action) {
    switch (action.type) {
        case 'competition_changed':
            return {
                ...state,
                defaultCompetition: action.value
            }
        case 'password_message_changed':
            return {
                ...state,
                password: {
                    ...state.password,
                    ['messages']: action.value,
                    ['success']: action.success

                }
            }
        case 'password_changed':
            return {
                ...state,
                password: {
                    ...state.password,
                    [action.for]: action.value
                }
            }
        case 'password_show':
            return {
                ...state,
                password: {
                    ...state.password,
                    [`${action.for}Show`]: !state.password[`${action.for}Show`]
                }
            }
        case 'email_message_changed':
            return {
                ...state,
                email: {
                    ...state.email,
                    ['messages']: action.value,
                    ['success']: action.success

                }
            }
        case 'email_changed':
            return {
                ...state,
                email: {
                    ...state.email,
                    [action.for]: action.value
                }
            }
        case 'settings_scoresheet_changed':
            return {
                ...state,
                settings: { 
                    scoresheetNew: action.value
                }
            }
        default:
            return state;
    }
}
const AccountPage = (props) => {
    const { defaultSelectedCompetition, user } = useContext(UserDataContext)
    const [state, dispatch] = useReducer(accountPageReducer, { ...props, ...{ defaultCompetition: defaultSelectedCompetition, scoresheetNew: user.scoresheetNew } }, accountPageInitalState)
    const { firebase } = useContext(FirebaseNewContext)
    const { teamsMap, usersMap } = useContext(CommonDataContext);
    const { globalSettings } = useContext(GlobalSettingsContext);
    const [toast, setToast] = React.useState({
        open: false,
        message: '',
        severity: 'info',
    });

    const competitionChange = useCallback((value) => {
        dispatch({
            type: 'competition_changed',
            value: value
        })
    }, [])

    const saveChanges = async () => {
        await firebase.patchUser(user.uid, { ...user, ...{ defaultCompetition: state.defaultCompetition, ...state.settings } }, defaultSelectedCompetition)
    }

    const submitButtonPressed = useCallback(() => {
        saveChanges()

        setToast({
            open: true,
            message: 'Default competition updated.',
            severity: 'success',
        });

    }, [state.defaultCompetition])

    const passwordChange = useCallback((forWhat, e) => {
        e.preventDefault()
        dispatch({
            type: 'password_changed',
            value: e.target.value,
            for: forWhat
        })
    }, [state.password])

    const passwordVisibilityChange = useCallback((forWhat, e) => {
        e.preventDefault()
        dispatch({
            type: 'password_show',
            for: forWhat
        })

    }, [state.password])

    const PasswordVisibility = (props) => {
        return (
            <InputAdornment position="start">
                <IconButton onClick={props.onClick}>
                    {props.show ? <VisibilityOff /> : <Visibility />}
                </IconButton>
            </InputAdornment>
        )
    }

    const savePasswordPressed = useCallback((e) => {
        e.preventDefault()
        dispatch({
            type: 'toggle_buttons',
        })

        const results = passwordValid(state.password.new, state.password.newConfirm)
        dispatch({
            type: 'password_message_changed',
            value: results,
        })

        const submit = async (results) => {
            if (results.length == 0) {
                const result = await firebase.updateUserPassword(state.password.new)
                dispatch({
                    type: 'password_error_changed',
                    value: result.reason,
                })
                // if result.succcess show good job dialog and reload the page on close

                // if success also update their email within our current firebase instance
                //const result = await firebase.patchUser(user.uid, { ...user, ...{ defaultCompetition: state.defaultCompetition } })
            }
            dispatch({
                type: 'toggle_buttons',
            })
        }
        submit(results)
    }, [state.password])

    const userEmailChanged = useCallback((forWhat, e) => {
        e.preventDefault()
        dispatch({
            type: 'email_changed',
            value: e.target.value.trim(),
            for: forWhat
        })

    }, [state.email, user])

    const emailValid = (email1, email2) => {
        let errors = []
        switch (true) {
            case !email1.trim() || !email2.trim():
                errors = errors.concat("Email fields cannot be blank")
                break;
            case email1 !== email2:
                errors = errors.concat("Emails do not match")
                break;
        }
        return errors
    }
    const passwordValid = (password1, password2) => {
        let errors = []
        switch (true) {
            case !password1.trim() || !password2.trim():
                errors = errors.concat("Passwords fields cannot be blank")
                break;
            case password1 !== password2:
                errors = errors.concat("Passwords do not match")
                break;
            case password1.length < 8:
                errors = errors.concat("Passwords must have at least 8 characters")
                break;
        }
        return errors
    }

    const changeEmailPressed = useCallback((e) => {
        e.preventDefault()
        dispatch({
            type: 'toggle_buttons',
        })

        const results = emailValid(state.email.new, state.email.newConfirm)
        dispatch({
            type: 'email_message_changed',
            value: results,
        })

        const submit = async (results) => {
            if (results.length == 0) {
                const result = await firebase.updateUserEmail(state.email.new)
                dispatch({
                    type: 'email_message_changed',
                    value: result.reason,
                })
                // if result.succcess show good job dialog and reload the page on close

                // TODO patch the user in the database
                //const result = await firebase.patchUser(user.uid, { ...user, ...{ defaultCompetition: state.defaultCompetition } })

            }
            dispatch({
                type: 'toggle_buttons',
            })
        }
        submit(results)

    }, [state.email])

    const scoresheetNewChanged = useCallback((_, checked) => {
        dispatch({
            type: 'settings_scoresheet_changed',
            value: checked,
        });
    }, []);

    const settingsSubmitPressed = useCallback(() => {
        saveChanges()

        setToast({
            open: true,
            message: 'Settings Updated.',
            severity: 'success',
        });

    }, [state.settings.scoresheetNew])

    return (
                <Grid2 container direction="column" sx={{ p: { xs: 2, sm: 3 }, gap: 3, mx: 'auto', width: '100%', }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography variant="h4" fontWeight={700} >
                            Account
                        </Typography>
                    </Box>

                    <Grid2 container direction="column" sx={{ gap: 3, maxWidth: 900 }}>
                        <Paper elevation={0} sx={{ p: { xs: 2, sm: 3 }, border: 1, borderColor: 'divider', borderRadius: 2 }}>
                            <Stack spacing={2}>
                                <Typography variant="h6">Default Competition</Typography>
                                <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    spacing={2}
                                    alignItems={{ xs: 'stretch', sm: 'center' }}
                                >
                                    <Box sx={{ flex: 1, minWidth: 260 }}>
                                        <CompetitionDropdown value={state.defaultCompetition} onChange={competitionChange} />
                                    </Box>
                                    <Box sx={{ textAlign: { xs: 'right', sm: 'right' } }}>
                                        <Button variant="contained" onClick={submitButtonPressed}>
                                            Save Competition
                                        </Button>
                                    </Box>
                                </Stack>
                            </Stack>
                        </Paper>

                        <Paper elevation={0} sx={{ p: { xs: 2, sm: 3 }, border: 1, borderColor: 'divider', borderRadius: 2 }}>
                            <Stack spacing={2}>
                                <Typography variant="h6">Password</Typography>

                                <Grid2
                                    container
                                    direction="column"
                                    sx={{
                                        '& .MuiTextField-root': { my: 1 },
                                    }}
                                >
                                    <TextField
                                        fullWidth
                                        sx={{ flex: 1 }}
                                        value={state.password.new}
                                        label="New password"
                                        type={state.password.newShow ? 'text' : 'password'}
                                        onChange={passwordChange.bind(this, 'new')}
                                        InputProps={{
                                            startAdornment: (
                                                <PasswordVisibility
                                                    onClick={passwordVisibilityChange.bind(this, 'new')}
                                                    show={state.password.newShow}
                                                />
                                            ),
                                        }}
                                    />

                                    <TextField
                                        fullWidth
                                        value={state.password.newConfirm}
                                        type={state.password.newConfirmShow ? 'text' : 'password'}
                                        label="Confirm password"
                                        onChange={passwordChange.bind(this, 'newConfirm')}
                                        InputProps={{
                                            startAdornment: (
                                                <PasswordVisibility
                                                    onClick={passwordVisibilityChange.bind(this, 'newConfirm')}
                                                    show={state.password.newConfirmShow}
                                                />
                                            ),
                                        }}
                                    />

                                    <FormErrorMessages errorMessages={state.password.messages} success={state.password.success} />
                                </Grid2>

                                <Box sx={{ textAlign: 'right' }}>
                                    <Button variant="contained" onClick={savePasswordPressed}>
                                        Save Password
                                    </Button>
                                </Box>
                            </Stack>
                        </Paper>

                        <Paper elevation={0} sx={{ p: { xs: 2, sm: 3 }, border: 1, borderColor: 'divider', borderRadius: 2 }}>
                            <Stack spacing={2}>
                                <Typography variant="h6">Email</Typography>

                                <Grid2
                                    container
                                    direction="column"
                                    sx={{
                                        '& .MuiTextField-root': { my: 1 },
                                    }}
                                >
                                    <TextField value={user.email} label="Current email" disabled fullWidth />

                                    <TextField
                                        value={state.email.new}
                                        label="New email"
                                        onChange={userEmailChanged.bind(this, 'new')}
                                        disabled
                                        sx={{ display: 'none' }}
                                    />
                                    <TextField
                                        value={state.email.newConfirm}
                                        label="Confirm new email"
                                        onChange={userEmailChanged.bind(this, 'newConfirm')}
                                        disabled
                                        sx={{ display: 'none' }}
                                    />

                                    <FormErrorMessages errorMessages={state.email.messages} />
                                </Grid2>

                                {/* Hidden per your current logic */}
                                <Box sx={{ textAlign: 'right', display: 'none' }}>
                                    <Button variant="contained" onClick={changeEmailPressed}>
                                        Change Email
                                    </Button>
                                </Box>
                            </Stack>
                        </Paper>

                {/* Pending invites section */}
                {user && user.pendingInvites && Object.keys(user.pendingInvites).length > 0 && (
                    <Paper elevation={0} sx={{ p: { xs: 2, sm: 3 }, border: 1, borderColor: 'divider', borderRadius: 2 }}>
                        <Stack spacing={2}>
                            <Typography variant="h6">Pending Invites</Typography>
                            {Object.keys(user.pendingInvites).map((compKey) => {
                                const invite = user.pendingInvites[compKey];
                                const compName = (globalSettings && globalSettings.competitions && globalSettings.competitions[compKey]) || compKey;
                                const teamNames = (invite.teams || []).map(tid => {
                                    // teamsMap is shaped as teamsMap[competition][teamId]
                                    const compTeams = (teamsMap && teamsMap[compKey]) || {};
                                    const teamObj = compTeams[tid] || teamsMap[tid];
                                    return teamObj ? (teamObj.teamName || teamObj.teamName || tid) : tid;
                                }).join(', ');
                                return (
                                    <Box key={compKey} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Box sx={{ flex: 1 }}>
                                            <Typography>Competition: {compName}</Typography>
                                            <Typography>Teams: {teamNames}</Typography>
                                        </Box>
                                        <Box>
                                            <Button variant="contained" onClick={async () => { try { await firebase.acceptInvite(user.uid, compKey); window.location.reload(false); } catch (e) { console.error(e); } }}>Accept</Button>
                                            <Button variant="outlined" sx={{ ml: 1 }} onClick={async () => { try { await firebase.declineInvite(user.uid, compKey); window.location.reload(false); } catch (e) { console.error(e); } }}>Decline</Button>
                                        </Box>
                                    </Box>
                                )
                            })}
                        </Stack>
                    </Paper>
                )}


                {/*
                <Paper elevation={0} sx={{ p: { xs: 2, sm: 3 }, border: 1, borderColor: 'divider', borderRadius: 2 }}>
                    <Stack spacing={2} justifyContent="left">
                        <Typography variant="h6">Settings</Typography>
                    
                        <FormGroup sx={{ width: 'fit-content' }}>
                            <Tooltip title="Checked: go to a new sheet after save. Unchecked: stay on the saved sheet.">
                                <FormControlLabel
                                    label="Continue to New"
                                    control={
                                        <Checkbox
                                            checked={!!state.settings.scoresheetNew}
                                            onChange={scoresheetNewChanged}
                                        />
                                    }
                                />
                            </Tooltip>
                        </FormGroup>

                        <Box sx={{ textAlign: { xs: 'right', sm: 'right' } }}>
                                <Button variant="contained" onClick={settingsSubmitPressed}>
                                    Save Settings
                                </Button>
                            </Box>
                    </Stack>
                </Paper>
                */}
            </Grid2>

            <Snackbar
                open={toast.open}
                autoHideDuration={3000}
                onClose={() => setToast((t) => ({ ...t, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setToast((t) => ({ ...t, open: false }))}
                    severity={toast.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {toast.message}
                </Alert>
            </Snackbar>
        </Grid2>
    );

}
// TODO - where we left off, success dialog messaing
//  from here reload the page on success
// TODO - confirm the user email gets updated in the application (not just firebase)
// TODO - delete the old form
// TODO - fix all the errors that come up when you have empty data

export default AccountPage
